import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  increase() { this.adjust(1) }
  decrease() { this.adjust(-1) }

  adjust(amount) {
    this.inputTargets.forEach((input) => {
      const fallback = input.name.match(/padding_(top|bottom)/) ? 32 : 16
      const value = Number.isFinite(input.valueAsNumber) ? input.valueAsNumber : fallback
      input.value = Math.max(0, Math.round(value) + amount)
      input.dispatchEvent(new Event("input", { bubbles: true }))
      input.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }
}
